export default __webpack_public_path__ + "static/media/student-muted.fca5c36a.svg";